module.exports = __webpack_public_path__ + "img/emoji_hlmm.7c8a16d8.png";